var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.98193L7.1885 9.47918H4.5625L6.687 11.0227L5.875 13.5197L8 11.9767L10.1245 13.5197L9.3125 11.0227L11.437 9.47918H8.811L8 6.98193ZM8.7095 10.7619L9.1475 12.1109L8 11.2769L6.8515 12.1109L7.2905 10.7619L6.1425 9.92793H7.5615L8 8.57893L8.4385 9.92793H9.857L8.7095 10.7619Z",
    fill: "#767A85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1643 6.62975V4.45525C11.1643 4.36425 11.1145 4.28775 11.044 4.24025L13.5 0.5H8.79125L8.00025 1.6865L7.20925 0.5H2.5L4.95575 4.24C4.91951 4.26315 4.88957 4.29494 4.86863 4.3325C4.84768 4.37007 4.83639 4.41225 4.83575 4.45525V6.62975C3.7155 7.54675 3 8.9395 3 10.5C3 13.2612 5.23875 15.5 8 15.5C8.17033 15.5 8.33867 15.4915 8.5045 15.4745C11.0288 15.2217 13 13.0912 13 10.5C13 8.9395 12.2845 7.54675 11.1643 6.62975ZM10.2065 0.75H11.7885L9.58225 4.05975L8.79125 2.87325L10.2065 0.75ZM10.3733 5.24625L10.6165 4.88175C10.6295 4.913 10.637 4.947 10.637 4.98275V6.0375C10.6363 6.10333 10.6096 6.16622 10.5627 6.2125C9.81275 5.763 8.938 5.5 8 5.5C7.09684 5.50019 6.21082 5.74661 5.43725 6.21275C5.39036 6.16641 5.36368 6.10342 5.363 6.0375V4.98275C5.36333 4.94675 5.37017 4.91308 5.3835 4.88175L5.62675 5.2465L10.3733 5.24625ZM4.2115 0.75H5.7935L8.6245 4.99625H7.0425L4.2115 0.75ZM8 14.75C5.653 14.75 3.75 12.8472 3.75 10.5C3.75 8.15275 5.653 6.25 8 6.25C10.347 6.25 12.25 8.15275 12.25 10.5C12.25 12.8472 10.347 14.75 8 14.75Z",
    fill: "#767A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.ef13d91672a892f3b4adabd7e8e40520.svg";
export { ForwardRef as ReactComponent };